package com.yogaaicoach.pages.auth

import com.yogaaicoach.pages.auth.CreateAccountViewModel
import com.yogaaicoach.scope
import kotlinx.coroutines.launch
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.span
import react.useEffectOnce
import react.useState
import web.cssom.ClassName
import web.html.InputType
import web.html.email
import web.html.password

internal external interface CreateAccountPageProps : Props {
    var viewModel: CreateAccountViewModel
    var onNavigateToVerifyEmail: (String) -> Unit
}

// Pixel-matched against CreateAccountScreen.kt (AuthPageLayout + FormSectionCard).
internal val CreateAccountPage = FC<CreateAccountPageProps> { props ->
    val viewModel = props.viewModel

    var email by useState(viewModel.email.value)
    var password by useState(viewModel.password.value)
    var confirmPassword by useState(viewModel.confirmPassword.value)
    var error by useState(viewModel.error.value)
    var isLoading by useState(viewModel.isLoading.value)

    useEffectOnce {
        scope.launch { viewModel.email.collect { email = it } }
        scope.launch { viewModel.password.collect { password = it } }
        scope.launch { viewModel.confirmPassword.collect { confirmPassword = it } }
        scope.launch { viewModel.error.collect { error = it } }
        scope.launch { viewModel.isLoading.collect { isLoading = it } }
    }

    div {
        className = ClassName("auth-page")

        img { className = ClassName("auth-logo"); src = "logo.png"; alt = "App logo" }
        p { className = ClassName("auth-brand"); +"Yoga AI Coach" }

        div {
            className = ClassName("form-section-card")

            p { className = ClassName("form-title"); +"Create Account" }

            p { className = ClassName("auth-error"); +error }

            FloatingLabelInput("create-email-input", "Email", InputType.email, email) { viewModel.onEmailChange(it) }
            FloatingLabelInput("create-password-input", "Password", InputType.password, password) { viewModel.onPasswordChange(it) }
            FloatingLabelInput("create-confirm-password-input", "Confirm Password", InputType.password, confirmPassword) { viewModel.onConfirmPasswordChange(it) }

            button {
                className = ClassName(if (isLoading) "primary-button loading" else "primary-button")
                disabled = isLoading
                onClick = { viewModel.createAccount { email -> props.onNavigateToVerifyEmail(email) } }
                if (isLoading) {
                    span { className = ClassName("button-spinner") }
                } else {
                    +"Create Account"
                }
            }
        }
    }
}
